import React, {Fragment} from "react";
import Select from "../../../form/Select";
import {PersonSelect} from "../../../../utils/formatters";
import TextInput from "../../../form/TextInput";
import {AbstractFilter, AbstractFilterProps} from "./AbstractFilter";

const queryFields = [
    {
        name: 'person_id',
        label: 'Személy',
        operators: [
            {
                name: '=',
                label: '='
            },
            {
                name: '!=',
                label: '!='
            },
        ],
        valueEditor: (props) => {
            return <div className="flex-grow-6">
                <Select
                    component="person"
                    storeType="remote"
                    placeholder="Személy"
                    label={false}
                    optionsTemplate={PersonSelect}
                    value={props.value}
                    objectValue={false}
                    disabled={props.disabled}
                    saveChanges={(field, value) => {
                        props.handleOnChange(value);
                    }}
                />
            </div>;
        }
    },
    {
        name: 'address.postcode',
        label: 'Irányítószám',
        operators: [
            { name: '=', label: '=' },
            { name: '!=', label: '!=' },
            { name: '<', label: '<' },
            { name: '>', label: '>' },
            { name: '<=', label: '<=' },
            { name: '>=', label: '>=' },
            { name: 'between', label: 'között' },
        ],
        valueEditor: (props) => {
            if (props.operator === "between") {
                const values = JSON.parse(JSON.stringify(Array.isArray(props.value) ? props.value : (props.value ? [props.value, null] : [null, null])));
                return <Fragment>
                    <div className="flex-grow-1">
                        <TextInput
                            placeholder="1123"
                            label={false}
                            value={(values[0] || null)}
                            disabled={props.disabled}
                            saveChanges={(field, value) => {
                                values[0] = value;
                                props.handleOnChange(values);
                            }}
                        />
                    </div>
                    <div className="flex-grow-1">
                        <TextInput
                            placeholder="2311"
                            label={false}
                            value={(values[1] || null)}
                            disabled={props.disabled}
                            saveChanges={(field, value) => {
                                values[1] = value;
                                props.handleOnChange(values);
                            }}
                        />
                    </div>
                </Fragment>;
            }
            return <div className="flex-grow-1">
                <TextInput
                    placeholder="1123"
                    label={false}
                    value={props.value}
                    saveChanges={(field, value) => {
                        props.handleOnChange(value);
                    }}
                />
            </div>;
        }
    },
    {
        name: 'email',
        label: 'Email',
        operators: [
            {
                name: '=',
                label: '='
            }
        ],
        valueEditor: (props) => {
            return <div className="flex-grow-6">
                <TextInput
                    placeholder="email@domain.com"
                    label={false}
                    value={props.value}
                    disabled={props.disabled}
                    saveChanges={(field, value) => {
                        props.handleOnChange(value);
                    }}
                />
            </div>;
        }
    },
];

export default class UserFilter extends React.Component<AbstractFilterProps, any> {

    render() {
        return (
            <AbstractFilter {...this.props} component="User" queryFields={queryFields} />
        );
    }
}